import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { IOtherInfo } from 'interfaces/Pricelist/IOtherInfoViewModel';
import './OtherInfo.scss';

const OtherInfo = (props: IPricelistMasterDetailProps) => {
  const { getOtherInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [otherInfo, setOtherInfo] = useState<IOtherInfo | undefined>();

  useEffect(() => {
    getOtherInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setOtherInfo(data);
        }
      })
      .catch((e) => setError(e));
  }, [props, getOtherInfo]);

  return (
    <Box className="otherInfo">
      {error && !otherInfo ? <Box className="errorBox">{error}</Box> : null}
      {!error && !otherInfo ? <Box><h2>Loading Other Info...</h2></Box> : null}
      {otherInfo ?
      <>
        <Box>
          <h2>Analysis</h2>
          <p>{otherInfo.Analysis}</p>

          <h2>Fixed Price</h2>
          <p>{otherInfo.IsFixedPrice ? 'Yes' : 'No'}</p>
        </Box>

        <Box>
          {otherInfo.Notes ? (
            <>
              <h2>Notes</h2>
              <p>{otherInfo.Notes}</p>
            </>
          ) : null}

          {otherInfo.OtherComments ? (
            <>
              <h2>Other Comments</h2>
              <p>{otherInfo.OtherComments}</p>
            </>
          ) : null}
        </Box>
      </> : null }
    </Box>
  );
};

export default React.memo(OtherInfo);
